"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatasetConfiguration = DatasetConfiguration;
var tslib_1 = require("tslib");
var debug_1 = tslib_1.__importDefault(require("debug"));
var lodash_1 = require("lodash");
var logger = (0, debug_1.default)('~/src/formcore/services/dataset-configuration');
function DatasetConfiguration(source, prefix, separator) {
    if (separator === void 0) { separator = '_'; }
    var prefixPattern = new RegExp("^".concat(prefix, "_"));
    var separatorPattern = new RegExp("".concat(separator), 'g');
    return Object.keys(source)
        .filter(function (key) { return key.startsWith(prefix); })
        .reduce(function (result, key) {
        var newKey = key
            .replace(prefixPattern, '')
            .replace(separatorPattern, '.');
        var value = source[key];
        try {
            value = JSON.parse(value);
        }
        catch (err) {
            logger("Could not parse ".concat(value));
        }
        (0, lodash_1.set)(result, newKey, value);
        return result;
    }, {});
}
//# sourceMappingURL=dataset-configuration.js.map